<header class="col-12 header-page row">
  <h1 class="col-md-6 col-sm-12 px-0 header__page__content__title">
    Pessoa Politicamente Exposta
  </h1>
  <div class="col-md-6 col-sm-12 px-0 header__button__historico">
    <a type="button" [routerLink]="['/historico-ppe']" class="btn btn-outline-primary col-md-6 col-xs-12 float-right">
      <span>Histórico de Declaração</span>
    </a>
    <div *ngIf="mostrarDeclaracoes">
      <button class="btn btn-primary col-md-12 col-xs-12" (click)="novaDeclaracao()">
        Nova declaração
      </button>
    </div>
  </div>
</header>
<main class="main__page__content col-xl-12 mx-0">
  <section class="main__page__header">
    <div class="col-7 px-0">
      <h2 class="main__page__content__title col-12 px-0">
        Formulário PPE
      </h2>
    </div>
  </section>
  <form class="main__page__content__form" [formGroup]="formData">
    <section>
      <section class="col-12 content-form">
        <div class="col-xl-4 px-0 content-form-ng-select">
          <label class="content__form__title__label">Selecione uma das opções</label>
          <ng-select [items]="politicallyExposedList" bindLabel="desc" bindValue="value" placeholder=""
            [placeholder]="'Selecione uma opção'" [searchable]="false" formControlName="politicallyExposed"
            (clear)="limparSelecao()" (close)="fecharNgSelect()"  [class.ng-select-disabled]="mostrarDeclaracoes">
          </ng-select>
        </div>
      </section>
      <section *ngIf="!formData.get('politicallyExposed')?.value && mostrarDeclaracoes && mostrarDeclaracoes">
        <h4
          *ngIf="(listaPerson && listaPerson.length > 0 || listaFamily && listaFamily.length > 0 || listRelationships && listRelationships.length > 0) && personStatement && personStatement.exposedPersonStatementItem.length > 0">
          Declarações atuais válidas até <b>{{personStatement.expirationDate | date: 'dd/MM/yyyy'}}</b>
        </h4>
        <ng-template #naoPossuiDeclaracoes>
          <p>Você não possui Declarações disponíveis</p>
        </ng-template>
        <section class="my-2"
          *ngIf="(listaPerson && listaPerson.length > 0 || listaFamily && listaFamily.length > 0 || listRelationships && listRelationships.length > 0) && personStatement && personStatement.exposedPersonStatementItem.length > 0">
          <div *ngIf="listaPerson && listaPerson.length > 0">
            <div class="mx-2 mt-1" *ngFor="let pessoa of personStatement?.exposedPersonStatementItem">
              <div role="tabpanel" class="collapsed color-white">
                <div class="accordion-body accordion-body-declaracoes mt-1">
                  <span class="col-12 px-0">
                    <b>{{pessoa.name}}</b>
                  </span>
                  <div class="row">
                    <span class="col-6 px-0">
                      <b>Data inicial: </b>
                      {{pessoa.initialDate | date: 'dd/MM/yyyy'}}
                    </span>
                    <span class="col-6 px-0">
                      <b>Data Final: </b>
                      {{pessoa.finalDate | date: 'dd/MM/yyyy'}}
                    </span>
                  </div>
                  <span class="col-12 px-0">
                    <b>Cargo: </b>
                    {{cargo[pessoa.positionId]}}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
      <section *ngIf="formData.get('politicallyExposed')?.value">
        <blockquote class="m-2 content-form-aviso">
          Você se declara uma pessoa politicamente exposta segundo os termos da Instrução MPS/PREVIC/DC n.º 18, de 24 de
          dezembro de 2014?
        </blockquote>
        <section>
          <formulario-cargo-politico [titulo]="'Caso você exerça ou tenha exercido um cargo político'"
            [tipoCargo]="statmentType.PESSOAL" (sendEmitter)="adicionarPolitico($event)">
          </formulario-cargo-politico>
          <section class="content-form-lista" *ngFor="let item of listaPerson; let i = index;">
            <div class="lista-row mx-1" [id]="'heading_'+ item.name" role="tap"
              (click)="addOrRemoveCollapse(listaPerson, item.name)">
              <div>
                <span>
                  <fa-icon [icon]="faChevronDown" class="mr-1"></fa-icon>
                </span>
                <span>
                  {{item.name}}
                </span>
              </div>
              <div class="lista-actions">
                <fa-icon class="card__header__icon lista-btn-close" size="2x" (click)="removePerson(1, i)"
                  [icon]="faSquareXmark"></fa-icon>
              </div>
            </div>
            <div [id]="'collapse_'+ item.name" role="tabpanel" class="collapse color-white">
              <div class="accordion-body">
                <span class="col-12 px-0">
                  <b>Nome:</b>
                  {{item.name}}
                </span>
                <div class="row">
                  <span class="col-6 px-0">
                    <b>Data inicial: </b>
                    {{item.initialDate | date: 'dd/MM/yyyy'}}
                  </span>
                  <span class="col-6 px-0">
                    <b>Data Final: </b>
                    {{item.finalDate | date: 'dd/MM/yyyy'}}
                  </span>
                </div>
                <span class="col-12 px-0">
                  <b>Cargo: </b>
                  {{cargo[item.exposedPersonPositionId]}}
                </span>
              </div>
            </div>
          </section>
        </section>
        <section>
          <formulario-cargo-politico [titulo]="'Caso seu familiar exerça ou tenha exercido um cargo político'"
            [tipoCargo]="statmentType.FAMILIAR" (sendEmitter)="adicionarPolitico($event)">
          </formulario-cargo-politico>
          <section class="content-form-lista" *ngFor="let item of listaFamily; let i = index;">
            <div class="lista-row mx-1" [id]="'heading_'+ item.name" role="tap"
              (click)="addOrRemoveCollapse(listaFamily, item.name)">
              <div>
                <span>
                  <fa-icon [icon]="faChevronDown" class="mr-1"></fa-icon>
                </span>
                <span>
                  {{item.name}}
                </span>
              </div>
              <div class="lista-actions">
                <fa-icon class="card__header__icon lista-btn-close" size="2x" (click)="removePerson(2, i)"
                  [icon]="faSquareXmark"></fa-icon>
              </div>
            </div>
            <div [id]="'collapse_'+ item.name" role="tabpanel" class="collapse color-white">
              <div class="accordion-body">
                <span class="col-12 px-0">
                  <b>Nome:</b>
                  {{item.name}}
                </span>
                <div class="row">
                  <span class="col-6 px-0">
                    <b>Data inicial: </b>
                    {{item.initialDate | date: 'dd/MM/yyyy'}}
                  </span>
                  <span class="col-6 px-0">
                    <b>Data Final: </b>
                    {{item.finalDate | date: 'dd/MM/yyyy'}}
                  </span>
                </div>
                <span class="col-12 px-0">
                  <b>Cargo: </b>
                  {{cargo[item.exposedPersonPositionId]}}
                </span>
              </div>
            </div>
          </section>
        </section>
        <section>
          <formulario-cargo-politico
            [titulo]="'Caso a pessoa de seu relacionamento próximo exerça ou tenha exercido um cargo político'"
            [tipoCargo]="statmentType.RELACIONAMENTO" (sendEmitter)="adicionarPolitico($event)">
          </formulario-cargo-politico>
          <section class="content-form-lista" *ngFor="let item of listRelationships; let i = index;">
            <div class="lista-row mx-1" [id]="'heading_'+ item.name" role="tap"
              (click)="addOrRemoveCollapse(listRelationships, item.name)">
              <div>
                <span>
                  <fa-icon [icon]="faChevronDown" class="mr-1"></fa-icon>
                </span>
                <span>
                  {{item.name}}
                </span>
              </div>
              <div class="lista-actions">
                <fa-icon class="card__header__icon lista-btn-close" size="2x" (click)="removePerson(3, i)"
                  [icon]="faSquareXmark"></fa-icon>
              </div>
            </div>
            <div [id]="'collapse_'+ item.name" role="tabpanel" class="collapse color-white">
              <div class="accordion-body">
                <span class="col-12 px-0">
                  <b>Nome:</b>
                  {{item.name}}
                </span>
                <div class="row">
                  <span class="col-6 px-0">
                    <b>Data inicial: </b>
                    {{item.initialDate | date: 'dd/MM/yyyy'}}
                  </span>
                  <span class="col-6 px-0">
                    <b>Data Final: </b>
                    {{item.finalDate | date: 'dd/MM/yyyy'}}
                  </span>
                </div>
                <span class="col-12 px-0">
                  <b>Cargo: </b>
                  {{cargo[item.exposedPersonPositionId]}}
                </span>
              </div>
            </div>
          </section>
        </section>
      </section>
      <div class="main__content__form__observacoes">
        <section class="text-information">
          <h4>
            Observações
          </h4>
          <ol class="mt-2">
            <li type="1">
              <p>
                De acordo com o inciso III do artigo 2º da Instrução Normativa da Secretaria de Previdência
                Complementar - MPS/PREVIC/DC n.º 18, considera-se pessoa politicamente exposta:
                “o agente público que desempenha ou tenha desempenhado, nos últimos cinco anos,
                no Brasil ou em
                país, território ou dependência estrangeira, cargo, emprego ou função pública relevante, assim
                como seus
                representantes, familiares e outras pessoas de seus relacionamento próximo”.
              </p>
              <p>Para efeito do inciso III acima, considera-se:</p>
              <ol>
                <li type="a">
                  <p>
                    Familiares: parentes de linha direta até o primeiro grau (pais e filhos), o cônjuge, o
                    companheiro, a companheira, o enteado e a enteada.
                  </p>
                </li>
                <li type="a">
                  <p>
                    Pessoas de seu relacionamento
                    próximo: pessoas que praticam atos em seu nome, mediante procuração.
                  </p>
                </li>
              </ol>
              <p>São considerados cargos, emprego ou função pública relevante:</p>
              <ol>
                <li type="I">
                  <p>os detentores de mandatos eletivos dos Poderes Executivo e Legislativo da União;</p>
                </li>
                <li type="I">
                  <p>os ocupantes de cargo no Poder Executivo da União:</p>
                  <ol>
                    <li type="a">
                      <p>de ministro de Estado ou equiparado;</p>
                    </li>
                    <li type="a">
                      <p>de natureza especial ou equivalente;</p>
                    </li>
                    <li type="a">
                      <p>
                        de presidente, vice-presidente e diretor, ou equivalentes, de autarquias, fundações
                        públicas,
                        empresas públicas ou sociedades de economia mista; e
                      </p>
                    </li>
                    <li type="a">
                      <p>do Grupo Direção e Assessoramento Superiores - DAS, nível 6, e equivalentes;</p>
                    </li>
                  </ol>
                <li type="I">
                  <p>
                    os membros do Conselho Nacional de Justiça, do Supremo Tribunal Federal e dos Tribunais
                    Superiores;
                  </p>
                </li>
                <li type="I">
                  <p>
                    os membros do Conselho Nacional do Ministério Público, o Procurador-Geral da República, o
                    Vice-Procurador-Geral da República, o Procurador-Geral do Trabalho, o Procurador-Geral da
                    Justiça
                    Militar, os Subprocuradores-Gerais da República e os Procuradores-Gerais de Justiça dos
                    Estados e do
                    Distrito Federal;
                  </p>
                </li>
                <li type="I">
                  <p>
                    os membros do Tribunal de Contas da União e o Procurador-Geral do Ministério Público
                    junto ao
                    Tribunal de Contas da União;
                  </p>
                </li>
                <li type="I">
                  <p>
                    os governadores de Estado e do Distrito Federal, os presidentes de Tribunal de Justiça,
                    de
                    Assembleia Legislativa ou da Câmara Distrital, e os presidentes de Tribunal ou Conselho de
                    Contas de
                    Estado, de Municípios e do Distrito Federal;
                  </p>
                </li>
                <li type="I">
                  <p>os prefeitos e os presidentes de Câmara Municipal das capitais de Estado.
              </ol>
            </li>
            <li type="1">
              <p>
                A íntegra da Instrução
                Normativa MPS/PREVIC/DC n.º 18, de 24/12/2014 encontra-se disponível na área restrita do
                portal
                da
                Fundação Copel <a (click)="goFCopel()"><a class="link-fcopel">www.fcopel.org.br</a></a>
              </p>
            </li>
          </ol>
        </section>
      </div>
      <div class="col-12 main-content-form-checkbox" *ngIf="!mostrarDeclaracoes">
        <div class="custom-control custom-checkbox">
          <input type="checkbox" class="custom-control-input" id="customcheckbox1" formControlName="acceptedterms">
          <label class="custom-control-label" for="customcheckbox1">
            Estou ciente e comprometo-me a informar a
            Fundação Copel, imediatamente, qualquer alteração da presente situação.
          </label>
        </div>
      </div>
    </section>
  </form>
</main>
<footer class="footer__content">
  <div class="col-xl-7 col-lg-6 col-sm-12">
    <button type="button" class="btn btn-outline-primary col-xl-5 col-lg-5 col-md-5 col-sm-12" (click)="goFCopel()">
      <span class="px-4"> Instrução Previc nº18 </span>
    </button>
  </div>
  <div class="col-xl-5 col-lg-6 col-sm-12 text-md-right">
    <div *ngIf="!mostrarDeclaracoes">
      <button class="btn btn-outline-primary col-xl-3 mr-xl-1 mr-lg-1 mr-md-1 mr-sm-0"
        *ngIf="formData.get('politicallyExposed')?.value" (click)="bloquearCampos()">
        Voltar
      </button>
      <button type="submit" class="btn btn-primary col-xl-5 col-lg-4 col-md-4 col-sm-12 float-right"
        [disabled]="!formData.get('acceptedterms')?.value || loading" (click)="saveStatement()">
        <!-- [disabled]="!formData.get('acceptedterms')?.value || loading"  -->
        <div class="confirmaDeclaracao">
          <div class="spinner-border" role="status" *ngIf="loading"></div>
          <span class="px-4"> Declarar </span>
        </div>
      </button>
    </div>
    <div *ngIf="mostrarDeclaracoes">
      <button class="btn btn-primary col-xl-6 col-lg-4 col-md-4 col-sm-12" (click)="novaDeclaracao()">
        Nova declaração
      </button>
    </div>
  </div>
</footer>